<div id="beneficiaries-view-container">
  <p
    class="mb-3 description"
    [innerHTML]="'beneficiaries_Description' | message | async"
  ></p>

  <app-no-items
    message="No beneficiary found"
    *ngIf="(list$ | async)?.length === 0"
  ></app-no-items>

  <div
    class="d-flex flex-column"
    *ngIf="(list$ | async)?.length > 0"
    appanimatecss="fadeIn delay-1s"
  >
    <div
      class="card beneficiary d-flex flex-fill"
      *ngFor="let item of list$ | async; let i = index"
    >
      <div class="d-flex align-items-center flex-row beneficiaryinfo">
        <div class="beneficiaries-data-1 d-flex flex-fill">
          <div class="badge badge-info">{{ i + 1 }}</div>

          <div class="icon me-1">
            <circle-progress
              [percent]="item.percentage"
              [radius]="45"
              [outerStrokeWidth]="4"
              [innerStrokeWidth]="2"
              [showSubtitle]="false"
              [outerStrokeColor]="
                'CIRCLE_PROGRESS.OUTERSTROKECOLOR' | translate
              "
              [toFixed]="2"
              [innerStrokeColor]="
                'CIRCLE_PROGRESS.INNERSTROKECOLOR' | translate
              "
              [animationDuration]="2000"
            ></circle-progress>
          </div>
          <div class="d-flex flex-fill flex-column ms-2">
            <h5 class="name">{{ item.name }}</h5>
            <div class="relationship d-flex align-items-center">
              <mat-icon>group</mat-icon>
              {{ item.relationship }}
            </div>
          </div>
        </div>
        <div class="beneficiaries-data-2 d-flex flex-fill">
          <div class="d-flex flex-fill ms-2 beneficiary-info">
            <app-readonly
              class="w-100"
              icon="bookmark_border"
              title="Type"
              [value]="item.beneficiaryTypeName"
            ></app-readonly>
          </div>
          <div class="d-flex flex-fill ms-2 beneficiary-info">
            <app-readonly
              class="w-100"
              icon="date_range"
              title="Expiration date"
              [value]="item?.expirationDate | date : 'dd/MM/yyyy'"
            ></app-readonly>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="components-actions" *ngIf="canEdit$ | async">
    <app-button
      *featuretoggle="updateBeneficiariesFeatureToggle"
      loading
      class="floar-right"
      title="Edit Beneficiary"
      icon="{{ 'BTN.beneficiary-view.edit.icon' | translate }}"
      (onClick)="onEditClick()"
    >
    </app-button>
  </div>
</div>
